// components/ChatMessages.tsx
import React, { useEffect, useRef } from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { useLanguage } from '../context/LanguageContext';
import { MessageItem } from './MessageItem';

export const ChatMessages: React.FC = () => {
  const { messages } = useClipShare();
  const { t } = useLanguage();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="chat-messages">
      {messages.length === 0 ? (
        <div className="message" style={{ 
          textAlign: 'center', 
          background: 'transparent', 
          border: '2px dashed var(--border)', 
          cursor: 'default' 
        }}>
          <div style={{ color: 'var(--text-secondary)' }}>
            {t.messagesWillAppear}<br />
            <small>{t.clickToCopy}</small>
          </div>
        </div>
      ) : (
        messages.map((message, index) => (
          <MessageItem 
            key={`${message.timestamp}-${index}`} 
            message={message} 
          />
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};
